import { Stack } from '@mui/material';
import { GridToolbarContainer } from '@mui/x-data-grid-pro';
import {
  GridToolbarColumnsButton,
  GridToolbarProps,
  GridToolbarResetButton,
  GridToolbarSearch,
} from '@issuemanager/apps/client/components';
import { IssueTypesGridToolbarAddType } from './issue-types-grid-toolbar-add-type';

export function IssueTypesGridToolbar(props: GridToolbarProps) {
  const { columns } = props;

  return (
    <GridToolbarContainer>
      <GridToolbarSearch />
      <GridToolbarColumnsButton columns={columns} />
      <GridToolbarResetButton />
      <Stack direction='row' flex={1} justifyContent='flex-end' spacing={1}>
        <IssueTypesGridToolbarAddType />
      </Stack>
    </GridToolbarContainer>
  );
}
